import { Badge, Icon } from 'gu-ui-kit'
import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
const BADGE_SETTINGS = {
  active: {
    startIcon: (
      <Icon
        size={'s'}
        name={'status active'}
        color={'Accent-Confirm-Primary'}
      />
    ),
    color: 'Label-Confirm',
    bgColor: 'Background-Confirm',
  },
  inactive: {
    startIcon: (
      <Icon
        size={'s'}
        name={'status pause-circle'}
        color={'Interface-Eighth'}
      />
    ),
    color: 'Label/Fifth',
    bgColor: 'Background-Quaternary',
  },
}
export const BadgeCell = ({ status }) => {
  const { t } = useTranslation()

  return (
    <Badge noWrap {...BADGE_SETTINGS[status]}>
      {t(
        `referral::referral_clients.filters.dropdown.items.status.options.${status}`,
      )}
    </Badge>
  )
}
BadgeCell.propTypes = {
  status: PropTypes.string,
}
